import { Col, Row } from 'reactstrap';
import BricksIcon from "./assets/bricks.png";
import GraphIcon from "./assets/graph.png";
import ProjectMagnifierIcon from "./assets/project-magnifier.png";
import TelephoneIcon from "./assets/telephone.png";

function ForContractors() {
  return (
    <div>
      <Row>
        <div className='text-center'>
          <h2 className={`display-6 fw-bold font-noto-serif`}>For Contractors</h2>
        </div>
      </Row>
      <Row className='mt-2'>
        <Col xs="2" className='align-content-center text-start gx-0'>
          <img className='w-75 ms-2' src={BricksIcon} alt="Camera Icon"/>
        </Col>
        <Col xs="10" className='text-center'>
          <p className='font-helvetica-world'>
            <b>Create Your Contractor Profile</b><br/>
            Set up your BUILDE account with your business
            information, certifications, and project photos.
            Your profile helps homeowners learn about
            your experience, style, and previous work.
          </p>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col xs="2" className='align-content-center text-start gx-0'>
          <img className='w-75 ms-2' src={ProjectMagnifierIcon} alt="Camera Icon"/>
        </Col>
        <Col xs="10" className='text-center'>
          <p className='font-helvetica-world'>
            <b>Browse & Accept Projects</b><br/>
            Explore renovation opportunities posted by
            verified homeowners in your area.
            Review project details, scope, budget, and timeline -
            and choose which ones to accept or decline
            based on your availability and expertise.
          </p>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col xs="2" className='align-content-center text-start gx-0'>
          <img className='w-75 ms-2' src={TelephoneIcon} alt="Camera Icon"/>
        </Col>
        <Col xs="10" className='text-center'>
          <p className='font-helvetica-world'>
            <b>Build Trust & Communicate Clearly</b><br/>
            Use BUILDE's built-in messaging to chat, schedule
            phone calls, or arrange the first in-person meeting.
            Confirm measurements, materials, and
            expectations before the project starts to ensure
            alignment with the homeowner.
          </p>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col xs="2" className='align-content-center text-start gx-0'>
          <img className='w-75 ms-2' src={GraphIcon} alt="Camera Icon"/>
        </Col>
        <Col xs="10" className='text-center'>
          <p className='font-helvetica-world'>
            <b>Work With Confidence & Guaranteed Payment</b><br/>
            Once both parties agree, the project is locked by
            a smart contract on blockchain.
            The homeowner's payment is held securely in
          </p>
        </Col>
      </Row>
    </div>
  );
}

export default ForContractors;
